import { em } from 'polished'
import styled, { css } from 'styled-components'

import { H1Small } from 'styles/components/typography'

export const Wrapper = styled.div`
  margin: 0 -${p => p.theme.indents.baseIndentXs};

  ${p => p.theme.mq.upMd} {
    height: auto;
  }
`

export const Inner = styled.div`
  display: block;

  ${p => p.theme.mq.upMd} {
    display: flex;
    flex-wrap: wrap;
    align-content: stretch;
  }

  ${({ isNoWrapContent }) =>
    isNoWrapContent &&
    css`
      ${p => p.theme.mq.upLg} {
        flex-wrap: nowrap;
      }
    `}
`

export const H1SmallStyled = styled(H1Small)`
  display: none;

  ${p => p.theme.mq.upLg} {
    display: block;
    text-align: center;
    line-height: 1.8;
    margin-bottom: ${p => em(60, p.theme.typography.h1MdSmallPx)};
  }
`
